import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom'
import { getShipmentTypeDurationApi } from '../../apiHelper/authService';
import { setSelectedShipDuration } from '../../redux/authModalSlice';
import { useDispatch } from 'react-redux';

const ShipmentDurationV2 = () => {
    const dispatch = useDispatch()
    const [shipDur, setShipDur] = useState();
    const [loading, setLoading] = useState(false)
    const getShipTypeDuration = async () => {
        setLoading(true);



        // const toastId = toast.loading("Fetching Ship Type Duration...");

        try {
            const data = await getShipmentTypeDurationApi();
            // setCategories(data);
            console.log(data.shipmentAndDuration);
            
            setShipDur(data.shipmentAndDuration || []);
            // toast.success("Ship Type Duration fetched successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            // toast.error(
            //     err?.message || "Something went wrong while fetching ship type duration.",
            //     { id: toastId }
            // );
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {

        getShipTypeDuration()


    }, [])


    console.log("Duration", shipDur)
    return (
      <div className="mb-40  ">
        {shipDur?.length < 2 && (
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Link to={"/create-shipment-duration"}>
              <button
                type="button"
                className="btn btn-primary radius-8 px-20 py-11 d-flex align-items-center gap-2 mb-20"
              >
                Create Type and Duration
                <Icon icon="mingcute:add-line" className="text-xl" />
              </button>
            </Link>
          </div>
        )}

        {loading ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              className="spinner-border"
              role="status"
              style={{
                color: "#243E85",
                width: "2rem",
                height: "2rem",
                borderWidth: "0.3em",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : shipDur?.length > 0 ? (
          <div className="row gy-4 ">
            {shipDur?.map((shipInfo) => (
              <div className="col-xxl-3 col-sm-6" key={shipDur?.id}>
                <div
                  className="card h-100 d-flex flex-column justify-content-between"
                  style={{
                    border: "2px solid #C2D2FF",
                    borderRadius: "20px",
                    // backgroundColor: "#F4F7FF",
                    padding: "24px 24px",
                  }}
                >
                  <div
                    className="d-flex flex-column align-items-center"
                    style={{ gap: "27px" }}
                  >
                    <div
                      style={{
                        backgroundColor: "#F4F7FF",
                        borderRadius: "10%",
                        padding: "12px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        icon={
                          shipInfo?.type === "AIR"
                            ? "mdi:airplane"
                            : "mdi:cargo-ship"
                        }
                        width="50"
                        height="50"
                        color="#243E85"
                      />
                    </div>

                    <span
                      style={{
                        color: "#868686",
                        fontWeight: 500,
                        fontSize: "20px",
                      }}
                    >
                      {shipInfo?.type}
                    </span>

                    <h6
                      className="mb-24"
                      style={{
                        textAlign: "center",
                        color: "#243E85",
                        fontWeight: "600",
                      }}
                    >
                      {shipInfo.duration} DAYS
                    </h6>
                  </div>

                  <Link
                    to={"/create-shipment-duration"}
                    onClick={() => dispatch(setSelectedShipDuration(shipInfo))}
                    className="btn btn-primary d-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "#243E85",
                      borderColor: "#243E85",
                      borderRadius: "8px",
                      fontWeight: 500,
                      justifyContent: "center",
                    }}
                  >
                    <Icon
                      icon="tabler:edit"
                      width="18"
                      height="18"
                      color="#fff"
                    />
                    EDIT
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            className="h-100 "
            style={{
              color: "black",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "50vh",
            }}
          >
            No Shipment Duration Found
          </div>
        )}
      </div>
    );
}

export default ShipmentDurationV2